import React, {useEffect, useMemo, useState} from 'react';
import {Platform} from 'react-native';
import {ScrollView} from 'react-native-gesture-handler';
import {NavigationProp} from '@react-navigation/native';
import {withForwardedNavigationParams} from 'react-navigation-props-mapper';
import Localized from 'src/constants/AppStrings';
import {getPreviousRouteName} from 'src/Util';
import Settings from 'src/Settings';
import {useFAQs} from './hooks/useFAQs';
import {useEmailSupport} from './hooks/useEmailSupport';
import BackSubheader from '../../../elements/BackSubheader';
import Styles from '../../../Styles';
import {getDescriber} from '../descriptor/DescriptorType';
import {FAQItem} from './components/FAQItem';
import {ContactSection} from './components/ContactSection';
import {ErrorModal} from './components/ErrorModal';
import UIManager from '../../../elements/ui/UIManager';
import AVText from '../../../elements/AVText';

interface HelpProps {
  navigation?: NavigationProp<any>;
}

const HelpScreen: React.FC<HelpProps> = ({navigation}) => {
  const [previousRoute, setPreviousRoute] = useState<string | null>(null);
  const faqs = useFAQs();
  const {showErrorModal, handleContactClick, hideModal} = useEmailSupport();
  const {getHelpStyleDescriptor} = getDescriber();
  const isRefiveOr365Pay = Settings.isRefiveAnd365Pay();

  useEffect(() => {
    const route = getPreviousRouteName(navigation?.getState()?.routes);
    setPreviousRoute(route);
  }, [navigation]);

  const scrollViewStyle = useMemo(
    () =>
      isRefiveOr365Pay && Platform.OS !== 'web'
        ? {backgroundColor: Styles.tabBarBackgroundColor}
        : null,
    [isRefiveOr365Pay],
  );

  return (
    <BackSubheader
      previousRoute={previousRoute}
      title={UIManager.getHelpLabel()}
    >
      <ScrollView style={scrollViewStyle}>
        <AVText
          style={getHelpStyleDescriptor(isRefiveOr365Pay)?.header}
          accessibilityRole="header"
        >
          {Localized.Labels.faq}
        </AVText>

        {faqs.map((faq, index) => (
          <FAQItem key={index} faq={faq} index={index} />
        ))}

        <ContactSection onContactClick={handleContactClick} />
      </ScrollView>

      <ErrorModal visible={showErrorModal} onClose={hideModal} />
    </BackSubheader>
  );
};

export default withForwardedNavigationParams<HelpProps>()(HelpScreen);
